export function formatNumber(num, point = 0) {
   if (num >= 1e12) return (num / 1e12).toFixed(point) + 'T'
   if (num >= 1e9) return (num / 1e9).toFixed(point) + 'B'
   if (num >= 1e6) return (num / 1e6).toFixed(point) + 'M'
   if (num >= 1e3) return (num / 1e3).toFixed(point) + 'K'
   return num ? num.toFixed(0) : 0
}
